export class KetoResult {
  maintenance: Maintenance;
  minimum: Minimum;
  desirable: Desirable;
  bmr: number;


  constructor() {
    this.maintenance = new Maintenance();
    this.minimum = new Minimum();
    this.desirable = new Desirable();
  }
}

export class Maintenance {
  energy: number;
  gramsFat: number;
  gramsProtein: number;
  gramsNetCarbs: number;
  energyFat: number;
  energyProtein: number;
  energyNetCarbs: number;
  percEnergyNetCarbs: number;
  percEnergyProtein: number;
  percEnergyFat: number;
}

export class Minimum {
  energy: number;
  gramsFat: number;
  gramsProtein: number;
  gramsNetCarbs: number;
  energyFat: number;
  energyProtein: number;
  energyNetCarbs: number;
  percEnergyNetCarbs: number;
  percEnergyProtein: number;
  percEnergyFat: number;
}

export class Desirable {
  energy: number;
  gramsFat: number;
  gramsProtein: number;
  gramsNetCarbs: number;
  energyFat: number;
  energyProtein: number;
  energyNetCarbs: number;
  percEnergyNetCarbs: number;
  percEnergyProtein: number;
  percEnergyFat: number;
}
